import { Breakpoint, Button, Color, SimpleMarkdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${Color.Gray100};
  padding: 40px 16px;
  display: flex;
  flex-direction: column;

  @media ${Breakpoint.SmallDesktop} {
    padding: 40px 24px;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 2px solid ${Color.Brand300};
`;

export const StyledHeaderTypography = styled(Typography)`
  color: ${Color.Gray600};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    max-width: 674px;
    gap: 40px;
    padding: 24px 0;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    margin-bottom: 0;
  }
`;

export const Image = styled.img`
  width: 100%;
  max-width: 462px;
  max-height: 362px;
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;

export const Description = styled(SimpleMarkdown)`
  p + p {
    padding-top: 32px;
    display: inline-block;
  }
`;
